import { render, staticRenderFns } from "./insurance.vue?vue&type=template&id=70797546&scoped=true&"
import script from "./index.ts?vue&type=script&lang=ts&"
export * from "./index.ts?vue&type=script&lang=ts&"
import style0 from "./insurance.vue?vue&type=style&index=0&id=70797546&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70797546",
  null
  
)

export default component.exports